import type { ReactNode } from "react";
import { cn } from "../tokens.js";

export interface SectionProps {
  title: string;
  action?: { label: string; href?: string; onClick?: () => void };
  children: ReactNode;
  className?: string;
}

export function Section({ title, action, children, className }: SectionProps) {
  return (
    <section className={cn("ui-section", className)}>
      <div className="ui-section__head">
        <h2 className="ui-section__title">{title}</h2>
        {action && (
          <a
            className="ui-section__action"
            href={action.href}
            onClick={action.onClick ? (event) => { event.preventDefault(); action.onClick?.(); } : undefined}
          >
            {action.label}
          </a>
        )}
      </div>
      {children}
    </section>
  );
}
